<section>
  <div class="tw-flex tw-items-center tw-justify-left tw-p-4">
    <div class="tw-mr-[10px]">
      <img
        class="tw-w-[50px]"
        src="assets/images/auth/account_user_icon.svg"
        alt="account user icon">
    </div>
    <div>
      <p class="tw-leading-[20px] tw-pt-2 tw-pb-[1px]">{{ userName }}</p>
      <p class="tw-flex tw-items-center tw-justify-left
          tw-text-[11px] tw-text-[#3880ff]">Edit Profile
        <ion-icon name="chevron-forward-outline"
          class="tw-text-[13px] tw-text-[#3a5d9b]"></ion-icon>
      </p>
    </div>
  </div>
  <p (click)="logout()"
    class="tw-flex tw-items-center tw-justify-left tw-border-t-2 tw-border-[#7898d2] tw-p-4">
    <!-- <ion-icon name="log-out-outline"
      class="tw-absolute tw-left-[30%] tw-text-[20px]
      tw-text-[#163962] tw-mr-[5px]"></ion-icon> Logout -->
      <img src="/assets/images/auth/logout_icon.svg" alt="logout icon" class="tw-mr-[10px]">
      <span class="tw-text-[13px] tw-text-[#ada8a8]" data-cy="logout-button">Log Out</span>
  </p>
</section>
